import { SxProps, Theme } from '@mui/material/styles';

/**
 * Tokens de forma, elevação e movimento do portal.
 * Cores ficam no tema (palette.brand / palette.background.subtle); aqui só o que não é cor.
 */

export const RADIUS = {
  control: 6,
  card: 12,
  block: 16,
};

// Sombras tingidas com o slate dos neutros (luz vinda de cima)
export const SHADOWS = {
  sm: '0 1px 2px rgba(15, 23, 42, 0.06)',
  md: '0 6px 16px -4px rgba(15, 23, 42, 0.12), 0 2px 4px rgba(15, 23, 42, 0.06)',
  lg: '0 16px 32px -8px rgba(15, 23, 42, 0.18), 0 4px 8px rgba(15, 23, 42, 0.06)',
};

export const MOTION = {
  fast: '150ms',
  base: '200ms',
  easeOut: 'cubic-bezier(0.22, 1, 0.36, 1)',
};

export const CONTENT_MAX_WIDTH = 1240;

/** Largura confortável de leitura para textos longos. */
export const READING_WIDTH = '70ch';

/** Algarismos de mesma largura para datas, números e valores. */
export const tabularNums = { fontVariantNumeric: 'tabular-nums' } as const;

/**
 * Card sem interação: borda discreta, sem reação ao hover.
 */
export const staticCardSx: SxProps<Theme> = {
  borderRadius: `${RADIUS.card}px`,
  border: 1,
  borderColor: 'divider',
  boxShadow: SHADOWS.sm,
  backgroundColor: 'background.paper',
};

/**
 * Card clicável: eleva 2px, reforça borda e sombra no hover; volta ao pressionar.
 */
export const clickableCardSx: SxProps<Theme> = {
  ...(staticCardSx as object),
  cursor: 'pointer',
  textDecoration: 'none',
  color: 'inherit',
  transition: `transform ${MOTION.base} ${MOTION.easeOut}, box-shadow ${MOTION.base} ${MOTION.easeOut}, border-color ${MOTION.base} ${MOTION.easeOut}`,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: SHADOWS.md,
    borderColor: 'brand.border',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
};
